import { render } from "./RecipiesIndex.vue?vue&type=template&id=6c200bc8"
import script from "./RecipiesIndex.vue?vue&type=script&lang=js"
export * from "./RecipiesIndex.vue?vue&type=script&lang=js"

import "./RecipiesIndex.vue?vue&type=style&index=0&id=6c200bc8&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__